import velocity from 'velocity-animate';
import bem from '../modules/bem';
import scroll from '../modules/scroll';
import utils from '../modules/utils';
import viewport from '../modules/viewport';

const LinksOverflow = require('../modules/links-overflow');
const RaceNav = require('./race-nav');
const variables = require('../../variables.json');

class SiteHeader {

	static get block() {
		return bem.block('site-header');
	}

	constructor($siteHeader){

		this.$header = $siteHeader;
		this.$nav = document.querySelector(SiteHeader.block.selector('site-nav'));
		this.$headerSecondary = document.querySelector(SiteHeader.block.selector('secondary'));
		this.$headerSecondaryInner = document.querySelector(SiteHeader.block.selector('secondary-inner'));
		this.$raceNav = document.querySelector(bem.block('race-nav').selector());
		this.$raceNavToggle = document.querySelector(bem.block('race-nav').selector('toggle'));
		this.$raceNavPlaceholder = document.querySelector(bem.block('race-nav').selector('placeholder'));
		this.$splashTrigger = document.querySelector(SiteHeader.block.selector('splash-trigger'));
		this.$topLinks = document.querySelector(SiteHeader.block.selector('top-links'));

		this.settings = {
			scroll: {
				direction: null,
				y: null
			},
			delay: 400,
			offset: variables['site-header'].primary + variables['site-header'].secondary + 10,
			position: {
				left: null
			},
			toggle: {
				width: null
			},
			splashTrigger: {
				width: null
			},
			fixedRN: false,
			raceNav: {
				width: null
			}
		};

		this.nav = false;
		this.raceNav = false;
		this.topLinks = false;

		this.init = this.init.bind(this);
		this.onResize = this.onResize.bind(this);
		this.onScroll = this.onScroll.bind(this);
		this.updateSettings = this.updateSettings.bind(this);

		this.toggleFixedRN = this.toggleFixedRN.bind(this);

		this.init();

	}

	init(){

		const onScroll = this.onScroll;

		this.nav = new LinksOverflow(this.$nav);

		this.raceNav = new RaceNav(this.$raceNav);

		this.topLinks = new LinksOverflow(this.$topLinks);

		viewport.addListener('site-header', this.onResize);
		this.onResize();

		scroll.addListener('site-header', onScroll);

	}

	onResize(){

		this.updateSettings();

		this.$headerSecondaryInner.style.paddingRight = this.settings.splashTrigger.width + 'px';

		this.topLinks.onResize();

	}

	onScroll(){

		const scrollTop = (document.documentElement && document.documentElement.scrollTop)
							|| document.body.scrollTop;

		this.settings.scroll.direction = scrollTop > this.settings.scroll.y ? 'down' : 'up';
		this.settings.scroll.y = scrollTop;

		const isActive = this.$raceNav.classList.contains(bem.states.active);

		const isFixed = this.settings.scroll.y >= this.settings.offset
						|| (isActive && this.settings.scroll.direction && this.settings.scroll.y > 10);

		// if it should be fixed, and it's not
		// or if it shouldn't be fixed, and it is
		if( (isFixed && !this.settings.fixedRN) || (!isFixed && this.settings.fixedRN) ){
			this.toggleFixedRN(isFixed);
		}

	}

	toggleFixedRN(force){

		const $raceNavToggle = this.$raceNavToggle;
		const $headerSecondaryInner = this.$headerSecondaryInner;

		const topLinks = this.topLinks;

		this.settings.fixedRN = force;

		this.$raceNav.classList.toggle(bem.states.fixed, force);

		if( force ){

			this.$raceNav.style.left = this.settings.position.left + 'px';
			this.$raceNav.style.width = this.settings.raceNav.width + 'px';

		}else{

			this.$raceNav.style.removeProperty('left');
			this.$raceNav.style.removeProperty('width');

		}

		$headerSecondaryInner.style.overflow = 'hidden';

		velocity($raceNavToggle, 'stop');
		velocity($headerSecondaryInner, 'stop');

		velocity($raceNavToggle, {
			opacity: force ? 1 : 0,
			translateX: force ? '0%' : '-100%'
		}, {
			visibility: force ? 'visible' : 'hidden',
			duration: 200
		});

		velocity($headerSecondaryInner, {
			paddingLeft: force ? this.settings.toggle.width : 0
		}, {
			duration: 200,
			complete: function(){

				$headerSecondaryInner.style.removeProperty('overflow');

				topLinks.onResize();

			}
		});

	}

	updateSettings(){

		const toggleStyle = window.getComputedStyle(this.$raceNavToggle);
		const splashStyle = window.getComputedStyle(this.$splashTrigger);

		this.settings.toggle.width = this.$raceNavToggle.offsetWidth
										+ parseFloat(toggleStyle.marginRight);

		this.settings.splashTrigger.width = this.$splashTrigger.offsetWidth
											+ parseFloat(splashStyle.marginLeft)
											+ parseFloat(splashStyle.right);

		this.settings.position.left = utils.getCoords(this.$raceNavPlaceholder).left;

		this.settings.raceNav.width = this.$raceNav.offsetWidth;

	}

}

module.exports = () => {
	const $siteHeader = document.querySelector(SiteHeader.block.selector());

	if( !$siteHeader ){
		return;
	}

	new SiteHeader($siteHeader); // eslint-disable-line no-new
};



// WEBPACK FOOTER //
// ./src/js/layout/site-header.js